import { render, staticRenderFns } from "./couponPrice.vue?vue&type=template&id=d181a19a&scoped=true&"
import script from "./couponPrice.vue?vue&type=script&lang=js&"
export * from "./couponPrice.vue?vue&type=script&lang=js&"
import style0 from "./couponPrice.vue?vue&type=style&index=0&id=d181a19a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d181a19a",
  null
  
)

export default component.exports